import { KnmKindCodesEnum } from 'APIPackage/DictionariesModule/enums/KnmKindCodesEnum';

import { IKnmForm } from '../../../KnmPackage/MainModule/interfaces/IKnmForm';

interface IMarkedField {
  appendShowMarkCondition?: (values: IKnmForm, availableUnplannedActivities: boolean) => boolean;
}

export const isFieldRequiredForNextStatusesInTypeWaitingCarriedOut = (
  fieldName: string | undefined,
  values: IKnmForm,
  availableUnplannedActivities: boolean,
): boolean => {
  if (!fieldName) {
    return false;
  }

  const idRegex = /\[\d+]/gi;
  const fieldNameTemplate = fieldName?.replaceAll(idRegex, '[{id}]');

  if (!fieldNameTemplate || !fieldsRequiredForNextStatusesInTypeWaitingCarriedOut[fieldNameTemplate]) {
    return false;
  }

  const markedField = fieldsRequiredForNextStatusesInTypeWaitingCarriedOut[fieldNameTemplate];

  return (
    !markedField.appendShowMarkCondition || markedField.appendShowMarkCondition(values, availableUnplannedActivities)
  );
};

const fieldsRequiredForNextStatusesInTypeWaitingCarriedOut: Record<string, IMarkedField> = {
  subjectNotifications: {
    appendShowMarkCondition: (values, availableUnplannedActivities) => {
      if (values.kindKnm?.code === KnmKindCodesEnum.VP) {
        return availableUnplannedActivities ? !values.notNotifySubject : true;
      }

      return (
        values.kindKnm?.code !== KnmKindCodesEnum.IV &&
        values.kindKnm?.code !== KnmKindCodesEnum.MZ &&
        values.kindKnm?.code !== KnmKindCodesEnum.KZ &&
        values.kindKnm?.code !== KnmKindCodesEnum.VK
      );
    },
  },
};
